export default "__VITE_ASSET__DKhEJgTb__"